import React from 'react';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export const SingleSelectWithArrayFilter = ({
  column: { filterValue, setFilter, preFilteredRows, id },
}: any) => {
  const options = React.useMemo(() => {
    const opts = new Set<string>();
    preFilteredRows.forEach((row: any) => {
      (row.values[id] || []).forEach((val: string) => opts.add(val));
    });
    return Array.from(opts);
  }, [id, preFilteredRows]);

  return (
    <Select
      displayEmpty
			style={{ fontSize: 'small', width: '100%' }}
      value={filterValue || ''}
      onChange={e => setFilter(e.target.value || undefined)}
    >
      <MenuItem value="" style={{ textTransform: 'capitalize', fontSize: 'small' }}>All</MenuItem>
      {options.map((option: string, i: number) => (
        <MenuItem key={i} value={option} style={{ textTransform: 'capitalize', fontSize: 'small' }}>
          {option}
        </MenuItem>
      ))}
    </Select>
  );
};